export default {
    url: '/companies',
    template: '<ui-view></ui-view>',
    abstract: true
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/manage/permissions/companies/index.js